import { Box, Modal, Typography } from "@mui/material";
import ShareContainer from "../BusinessList/ShareContainer";
import QRCodeContainer from "../QRCodeContainer";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: { xs: "90%", sm: "680px" },
    maxHeight: "90%",
    overflowY: "auto",
    width: { xs: "90%", sm: "300px" },
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
    margin: "0px 0px",
    p: { xs: 2, sm: "26px" },
};

interface ShareBusinessModalProps {
    open: boolean;
    close: () => void;
    link: string;
    businessName: string;
}

const ShareBusinessModal = ({ open, close, link, businessName }: ShareBusinessModalProps) => {
    return (
        <Modal
            open={open}
            onClose={close}
            aria-labelledby="share-business-modal-title"
            aria-describedby="share-business-modal-description"
        >
            <Box sx={style}>
                {/* Modal Header */}
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <Typography sx={{
                        fontSize: 20,
                        fontWeight: 500,
                        textAlign: "center",
                    }}>
                        {businessName}
                    </Typography>
                </Box>

                {/* QR Code Section */}
                <Box sx={{ textAlign: "center", mt: 2.5, mb: 1.5, justifyContent: "center", display: "flex", mx: "auto", width: "100%" }}>
                    <QRCodeContainer link={link} />
                </Box>

                {/* ShareContainer for Share, Open, and Copy Options */}
                <Box sx={{ textAlign: "center", justifyContent: "center", display: "flex", mx: "auto", width: "100%" }}>
                    <ShareContainer link={link} />
                </Box>
            </Box>
        </Modal>
    );
};

export default ShareBusinessModal;
